import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('@/views/auth/Login'),
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      meta: {
        requiresAuth: true,
      },
      children: [
        // Organizations
        {
          name: 'Organizations',
          path: '/organizations',
          component: () => import('@/views/dashboard/organizations/OrganizationList'),
        },
        {
          name: 'Create Organization',
          path: '/organizations/create',
          component: () => import('@/views/dashboard/organizations/CreateOrganization'),
        },
        {
          name: 'Organization Details Landing Page',
          path: '/organizations/:organizationId',
          component: () => import('@/views/dashboard/organizations/OrganizationDetailsLandingPage'),
        },
        {
          name: 'Edit Organization Details',
          path: '/organizations/edit/:organizationId',
          component: () => import('@/views/dashboard/organizations/EditOrganization'),
        },
        // Users
        {
          name: 'Users',
          path: '/users',
          component: () => import('@/views/dashboard/users/Users'),
        },
        {
          name: 'Create User',
          path: '/users/create',
          component: () => import('@/views/dashboard/users/CreateUser'),
        },
         // DigiBoards
         {
          name: 'DigiBoards',
          path: '/digi-boards',
          component: () => import('@/views/dashboard/digiboards/DigiBoardsLandingPage'),
        },
        {
          name: 'Create DigiBoards',
          path: '/digi-boards/create',
          component: () => import('@/views/dashboard/digiboards/CreateDigiBoards'),
        },
        {
          name: 'DigiBoard Contents',
          path: '/digi-boards/:id',
          component: () => import('@/views/dashboard/digiboards/DigiBoardDetailsLandingPage'),
        },
        {
          name: 'Edit DigiBoard',
          path: '/digi-boards/edit/:id',
          component: () => import('@/views/dashboard/digiboards/EditDigiBoard'),
        },
        // Payments
        {
          name: 'Pricing',
          path: '/digi-boards/:externalid/time-slots/:digiBoardTimeSlotId/products',
          component: () => import('@/views/dashboard/digiboards/prices/DigiBoardTimeSlotPrices'),
        },
        {
          name: 'Payments',
          path: '/payments',
          component: () => import('@/views/dashboard/payments/PaymentsLandingPage'),
        },
        {
          name: 'Product Category Prices',
          path: '/product-category/:productcategoryid/prices',
          component: () => import('@/views/dashboard/payments/product/ProductCategoryPrices'),
        },
        // support
        {
          name: 'Support Tickets',
          path: '/support',
          component: () => import('@/views/dashboard/support/Support'),
        },
        {
          name: 'Edit Support Ticket',
          path: '/support/:id',
          component: () => import('@/views/dashboard/support/EditSupportTicket'),
        },
        // Account Control
        {
          name: 'Settings',
          path: '/settings',
          component: () => import('@/views/dashboard/settings/Settings'),
        },
        // Widgets
        {
          name: 'Widgets',
          path: '/widgets',
          component: () => import('@/views/dashboard/widgets/Widgets'),
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user');

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/');
    return;
  }

  next();
});

export default router;
